import { apiSign } from './encript.js'
import { getCurrentTime } from './timeformat'
import { getToken } from './auth'
export function getRequestHead () {
  const apiKey = 'com.soundx.supervoice.001'
  const appVersion = '27c32f1ab30c32f68a388b2e5732b306'
  const platForm = 'mp-weixin'
  const ts = getCurrentTime()
  const apiSecret = '27c32f1ab30c32f68a388b2e5732b306'
  const sign = apiSign(apiKey, appVersion, platForm, ts, apiSecret)

  // 请求head
  const header = {
    apikey: apiKey,
    appversion: appVersion,
    platform: platForm,
    ts: ts,
    sign: sign
  }
  const token = getToken()
  // 请求头增加token
  if (token) {
    header.Authorization = 'Bearer ' + token
  }

  return header
}
